import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserFollowedByLoadAction,
  UserFollowedByLoadFulfilledAction,
  UserFollowedByLoadPendingAction,
} from '../../domains/userFollowedBy/actions.types';
import { UserHeaderLoadPendingAction } from '../../domains/userHeaderLoad/actions.types';
import { User } from '../users/types';

import { UserFollowedBy, UsersFollowedBy } from './types';

export type { UserFollowedByLoadAction };

const initialState: UsersFollowedBy = {};

const initialUserFollowedBy: UserFollowedBy = {
  id: '',
  followedBy: [],
  cursor: null,
  hasNextPage: false,
  totalCount: 0,
  status: 'notRequested',
};

const stateWithPendingFollowedBy = (
  state: UsersFollowedBy,
  { id, isInitialLoad }: UserFollowedByLoadPendingAction['payload']
): UsersFollowedBy => {
  const followedBy = isInitialLoad ? initialUserFollowedBy : state[id];

  return addToRecord(state, id, { ...followedBy, status: 'pending' });
};

const stateWithFulfilledFollowedBy = (
  state: UsersFollowedBy,
  { id, entities, isInitialLoad }: UserFollowedByLoadFulfilledAction['payload']
): UsersFollowedBy => {
  const { cursor, hasNextPage, totalCount, followedBy: newFollowedBy } = entities.followedBy[id];
  const followedBy = isInitialLoad ? newFollowedBy : [...state[id].followedBy, ...newFollowedBy];

  const fulfilledFollowedBy: UserFollowedBy = {
    id,
    followedBy: [...new Set(followedBy)],
    cursor,
    hasNextPage,
    totalCount,
    status: 'fulfilled',
  };

  return addToRecord(state, id, fulfilledFollowedBy);
};

const stateWithRejectedFollowedBy = (state: UsersFollowedBy, id: User['id']): UsersFollowedBy =>
  updateRecord(state, id, { status: 'rejected' });

const clearFollowedBy = (state: UsersFollowedBy, { id }: UserHeaderLoadPendingAction['payload']): UsersFollowedBy => {
  const followedBy = initialUserFollowedBy;

  return addToRecord(state, id, followedBy);
};

const reducer: Reducer<UsersFollowedBy, UserFollowedByLoadAction | UserHeaderLoadPendingAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'USER_HEADER.LOAD_PENDING':
      return clearFollowedBy(state, action.payload);
    case 'USER_FOLLOWED_BY.LOAD_PENDING':
      return stateWithPendingFollowedBy(state, action.payload);
    case 'USER_FOLLOWED_BY.LOAD_FULFILLED':
      return stateWithFulfilledFollowedBy(state, action.payload);
    case 'USER_FOLLOWED_BY.LOAD_REJECTED':
      return stateWithRejectedFollowedBy(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;
